import PropTypes from 'prop-types';

const StructuredData = ({ data }) => {
  const defaultData = {
    '@context': 'http://schema.org',
  };

  const structuredData = Object.assign({}, defaultData, data);

  return (
    <script
      id={`structured-data-${data['@type']}`}
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
    />
  );
};
StructuredData.propTypes = {
  data: PropTypes.object,
};

export default StructuredData;
